import api from 'api';

export const loadBusinessPartnerTable = api('POST /api/business-partners/grid');
export const loadBusinessPartnerDetails = api(
  'GET /api/business-partners/:id/details'
);
export const loadBusinessPartner = api('GET /api/business-partners/:id');
export const createBusinessPartner = api('POST /api/business-partners');
export const updateBusinessPartner = api('PUT /api/business-partners/:id');

export const archiveBusinessPartner = api(
  'POST /api/business-partners/:id/archive'
);
export const restoreBusinessPartner = api(
  'POST /api/business-partners/:id/restore'
);
export const moveToTestBusinessPartner = api(
  'POST /api/business-partners/:id/in-test'
);
export const removeBusinessPartner = api(
  'POST /api/business-partners/:id/delete'
);

export const exportAffiliates = api('GET /api/business-partners/export');
